import { IFormValidation } from '@aston/foundation';

export class IUpdateSubsidiaryUserInactivityCommandValidator implements IFormValidation {
	ruleset = 'updateSubsidiaryUserInactivityCommandValidator';
	fields = {
		Begin: 'Begin',
		End: 'End',
	};
}

export const UpdateSubsidiaryUserInactivityCommandValidator = new IUpdateSubsidiaryUserInactivityCommandValidator();
